
const Testimonials = () => {
  const testimonials = [
    {
      tstmn:
        "Gr8 Appers is a great program designed for students like us to plan our future and have knowledge about what career suits best for us. The report organizes career choices that suit our personality and skills. It helps us put our interests and skills in order.",
      name: "Anvika H",
      designation: "8th Standard, Delhi Public School, Nacharam",
    },
    {
      tstmn:
        "Gr8 Appers is a wonderful application to gain clarity on different career options. It is unique as it gives a clear outlook on one's skills and aptitude towards different subjects. The report is distinctive to each person. It implores the mind to think beyond the regular career streams.",
      name: "Keertana",
      designation: "12th class, Obulreddy College",
    },
  ];
  return (
    <div id="testimonials" className="testimonials-section">
      <div className="container">
        <h3>
          <b>Happy Students</b> With Gr8 Appers
        </h3>
        <div className="testimonials">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial" key={index}>
              <p>"{testimonial.tstmn}"</p>
              <h4>{testimonial.name}</h4>
              <span>{testimonial.designation}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
